import classes from 'classnames';
import { Timeout } from 'components/index';
import { SECONDS_TO_WAIT_RESEND } from '../../constants';

type VerificationActionProps = {
  timerVisible: boolean;
  pending: boolean;
  onAction: () => void;
  onTimeout: () => void;
  buttonText: string;
  dataTest: string;
  // For multi using
  timerName: string;
  seconds?: number;
};

const Timer = ({
  timerVisible,
  pending,
  onAction,
  onTimeout,
  buttonText,
  dataTest,
  timerName,
  seconds = SECONDS_TO_WAIT_RESEND,
}: VerificationActionProps) => {
  return (
    <div className="my-1 font-light flex items-center w-full text-[15px]">
      {timerVisible ? (
        <>
          <Timeout
            seconds={seconds}
            onTimeout={onTimeout}
            timerName={timerName}
            className="w-12 block text-[15px]"
            dataTest={`${dataTest}-timeout`}
          />

          <div className="text-muted" data-test={`${dataTest}-message`}>
            {buttonText}
          </div>
        </>
      ) : (
        <button
          type="button"
          onClick={onAction}
          className={classes(
            'text-[15px]',
            pending ? 'text-muted' : 'text-primary',
          )}
          data-test={`${dataTest}-button`}
          disabled={pending}
        >
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default Timer;
